import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { HelpCircle, CalendarCheck, ArrowLeftRight, SlidersHorizontal, BookMarked, PencilLine, Dumbbell } from 'lucide-react';

const STEPS = [
  { icon: CalendarCheck, title: 'Your Meal Plan', text: 'Open Nutrition → My Meal Plan to see today\'s meals from your personalised programme. It opens first every time.' },
  { icon: CalendarCheck, title: 'Follow the plan', text: 'Tick each meal as you eat it. Your calories and protein for the day update automatically.' },
  { icon: ArrowLeftRight, title: 'Swap a meal', text: 'Tap Swap Meal to pick another YourReGen-approved recipe. Portions are recalculated to fit your day.' },
  { icon: SlidersHorizontal, title: 'Adjust portions', text: 'In Templates, tap Edit Portions to change the grams of a meal\'s foods. The totals recalculate as you type.' },
  { icon: BookMarked, title: 'Approved templates', text: 'Templates lists meals from the YourReGen Meal Library. Log them as is or with your own portions.' },
  { icon: PencilLine, title: 'Log anything else', text: 'Ate something that isn\'t in the library? Use Build a Meal to log it from the food database.' },
  { icon: Dumbbell, title: 'Training & Recovery', text: 'Use the menu to open Training (today\'s session, week view, swaps) and Recovery (sleep, steps and recovery tools).' },
];

export function AppTour({ label = 'How it works', className = '' }) {
  const [open, setOpen] = useState(false);
  const [i, setI] = useState(0);
  const s = STEPS[i];
  const Icon = s.icon;
  return (
    <>
      <button onClick={() => { setI(0); setOpen(true); }} data-testid="app-tour-open"
        className={`inline-flex items-center gap-1.5 text-xs text-[#00C8FF] hover:underline ${className}`}>
        <HelpCircle className="w-3.5 h-3.5" /> {label}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-regen-card border-[var(--c-hair)] max-w-sm" data-testid="app-tour">
          <DialogHeader><DialogTitle className="text-base">Quick guide · {i + 1} of {STEPS.length}</DialogTitle></DialogHeader>
          <div className="flex flex-col items-center text-center gap-3 py-2" data-testid={`app-tour-step-${i + 1}`}>
            <div className="w-12 h-12 rounded-2xl bg-[#00C8FF]/15 flex items-center justify-center"><Icon className="w-6 h-6 text-[#00C8FF]" /></div>
            <div className="font-display font-bold">{s.title}</div>
            <p className="text-sm text-muted-foreground leading-relaxed">{s.text}</p>
          </div>
          <div className="flex justify-center gap-1.5">{STEPS.map((_, k) => <span key={k} className={`h-1.5 rounded-full transition-all ${k === i ? 'w-5 bg-[#00C8FF]' : 'w-1.5 bg-[var(--c-hair)]'}`} />)}</div>
          <div className="flex gap-2 mt-2">
            <Button variant="outline" onClick={() => setOpen(false)} data-testid="app-tour-skip" className="flex-1 border-[var(--c-hair)]">{i === STEPS.length - 1 ? 'Close' : 'Skip'}</Button>
            {i > 0 && <Button variant="outline" onClick={() => setI(i - 1)} data-testid="app-tour-back" className="border-[var(--c-hair)]">Back</Button>}
            {i < STEPS.length - 1 && <Button onClick={() => setI(i + 1)} data-testid="app-tour-next" className="flex-1 bg-[#00C8FF] text-[#081726] font-semibold">Next</Button>}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
